import {PostExamsCancel} from 'domain/usecases';
import {RemotePostExamsCancel} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookedFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makePostExamsCancelBooked = (): PostExamsCancel =>
	new RemotePostExamsCancel(
		makeBFFApiUrl(BookedFlowEndPoints.examsCancel),
		makeAuthorizeHttpClientDecorator(),
	);
